export default __webpack_public_path__ + "static/media/BCA20.2d6ca0d2.jpg";